import { ToursSearch } from 'package-types';

import { ChosenFlights } from '../../interfaces/offer-management';

export class SelectionState {
  selectedOffer?: ToursSearch.Offer;
  selectedFlights: ChosenFlights = { from: undefined, to: undefined };
}
